import React from 'react';

const Wishlisttwo = () => {
  return (
    <div style={{
      fontFamily: 'sans-serif',
      padding: '16px',
      backgroundColor: '#f8f8f8',
      minHeight: '100vh',
      boxSizing: 'border-box'
    }}>
      {/* Header */}
      <div style={{
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: '18px',
        marginBottom: '16px'
      }}>
        Profile
      </div>

      {/* Status buttons */}
      <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', marginBottom: '16px' }}>
        <button style={{
          backgroundColor: '#E74C3C',
          border: 'none',
          borderRadius: '24px',
          padding: '8px 24px',
          color: 'white',
          fontWeight: 'bold',
          fontSize: '16px'
        }}>Pending</button>
        <button style={{
          backgroundColor: '#F1C40F',
          border: 'none',
          borderRadius: '24px',
          padding: '8px 24px',
          color: 'black',
          fontWeight: 'bold',
          fontSize: '16px'
        }}>Approved</button>
      </div>

      {/* Card */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '10px',
        padding: '16px',
        boxShadow: '0 0 10px rgba(0,0,0,0.05)',
        border: '1px solid #ddd',
      }}>
        <div style={{
          borderBottom: '1px solid #eee',
          paddingBottom: '8px',
          marginBottom: '12px',
          fontWeight: 'bold',
          textAlign: 'center'
        }}>New Buyer Enquiry</div>

        <div style={{ marginBottom: '12px' }}>
          <div style={{ fontWeight: 'bold' }}>Naveen</div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
          <div><strong>Profession</strong></div>
          <div>Private Job</div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
          <div><strong>Plans to Buy In:</strong></div>
          <div>&gt; 3 months</div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>
          <div><strong>Funding Plan</strong></div>
          <div>Self Funded</div>
        </div>

        {/* Approval prompt */}
        <div style={{
          textAlign: 'center',
          fontWeight: 'bold',
          marginBottom: '12px'
        }}>
          Approve this Enquiry?
        </div>

        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '40px',
          alignItems: 'center',
          marginBottom: '16px'
        }}>
          {/* Deny */}
          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              border: '1px solid #E74C3C',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: '24px',
              color: '#E74C3C'
            }}>×</div>
            <div style={{ fontWeight: 'bold', marginTop: '6px' }}>Deny</div>
          </div>

          {/* Approve */}
          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              backgroundColor: '#1ABC9C',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: '24px',
              color: 'white'
            }}>✔</div>
            <div style={{ fontWeight: 'bold', color: '#1ABC9C', marginTop: '6px' }}>Approve</div>
          </div>
        </div>
      </div>

      {/* Already Sold Out */}
      <div style={{
        marginTop: '20px',
        display: 'flex',
        justifyContent: 'center'
      }}>
        <button style={{
          border: '1px solid red',
          color: 'red',
          fontWeight: 'bold',
          borderRadius: '24px',
          padding: '8px 24px',
          background: 'white'
        }}>Already Sold Out</button>
      </div>

      {/* Bottom Navigation */}
      <div style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        backgroundColor: '#fff',
        borderTop: '1px solid #ddd',
        display: 'flex',
        justifyContent: 'space-around',
        padding: '8px 0'
      }}>
        {["Home", "Construction& Interiors", "Post", "Home Services", "Profile"].map((item, idx) => (
          <div key={idx} style={{ fontSize: '12px', textAlign: 'center' }}>
            <div style={{ fontSize: '18px' }}>⌂</div>
            {item}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Wishlisttwo;
